/**
 * 学习乐园 · 连连看题材包：元素符号（lianliankan/pack-yuansu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：元素符号连中文名（「H」连「氢」）。note 存原子序数
 * （「1 号 氢」）——配上的那一瞬顺口报一遍，符号、名称、序号三者
 * 挂钩；初中化学「前 20 号」口径一次记全。
 * 盘面 5×8=40 格：20 对全上，一局正好把 1~20 号过一遍——这是本包
 * 特意排满不抽局的原因（序号是顺序知识，抽局会断线）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.yuansu = {
    id: 'yuansu',
    name: '元素符号',
    hint: 'H 连氢，前 20 号一轮记全',
    kind: 'rel',
    cols: 5,
    rows: 8,
    pairs: [
      { l: 'H', r: '氢', note: '1 号 氢' },
      { l: 'He', r: '氦', note: '2 号 氦' },
      { l: 'Li', r: '锂', note: '3 号 锂' },
      { l: 'Be', r: '铍', note: '4 号 铍' },
      { l: 'B', r: '硼', note: '5 号 硼' },
      { l: 'C', r: '碳', note: '6 号 碳' },
      { l: 'N', r: '氮', note: '7 号 氮' },
      { l: 'O', r: '氧', note: '8 号 氧' },
      { l: 'F', r: '氟', note: '9 号 氟' },
      { l: 'Ne', r: '氖', note: '10 号 氖' },
      { l: 'Na', r: '钠', note: '11 号 钠' },
      { l: 'Mg', r: '镁', note: '12 号 镁' },
      { l: 'Al', r: '铝', note: '13 号 铝' },
      { l: 'Si', r: '硅', note: '14 号 硅' },
      { l: 'P', r: '磷', note: '15 号 磷' },
      { l: 'S', r: '硫', note: '16 号 硫' },
      { l: 'Cl', r: '氯', note: '17 号 氯' },
      { l: 'Ar', r: '氩', note: '18 号 氩' },
      { l: 'K', r: '钾', note: '19 号 钾' },
      { l: 'Ca', r: '钙', note: '20 号 钙' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
